import React, { useState } from 'react';
import { Smartphone, X, RefreshCw } from 'lucide-react';
import { useIsDemo } from '../../hooks/useIsDemo';

/**
 * Bouton flottant (mode démo) permettant aux testeurs de visualiser la
 * web app mobile admin dans un cadre téléphone, à la manière de l'aperçu preview.
 * Rendu uniquement pour les comptes démo, hors aperçu (évite la récursion).
 */
const DemoMobileAppButton = () => {
  const isDemo = useIsDemo();
  const [open, setOpen] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  // Ne pas s'afficher à l'intérieur de l'aperçu lui-même (récursion).
  const insidePreview = typeof window !== 'undefined'
    && new URLSearchParams(window.location.search).get('appview') === '1';

  if (!isDemo || insidePreview) return null;

  const buildSrc = () => {
    const p = new URLSearchParams(window.location.search);
    p.set('appview', '1');
    return `${window.location.pathname}?${p.toString()}`;
  };

  return (
    <>
      <button
        onClick={() => { setReloadKey((k) => k + 1); setOpen(true); }}
        data-testid="demo-mobile-app-btn"
        className="hidden lg:flex fixed bottom-24 right-6 z-[9999] items-center gap-2 px-4 py-2.5 rounded-full bg-slate-900 text-white font-semibold shadow-lg hover:bg-slate-800 transition-colors"
        title="Voir l'application web admin"
      >
        <Smartphone size={16} />
        <span className="text-sm tracking-wide">Voir l'app admin</span>
      </button>

      {open && (
        <div
          className="fixed inset-0 z-[10001] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setOpen(false)}
          data-testid="demo-mobile-app-overlay"
        >
          <div className="relative flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
            {/* Barre d'actions */}
            <div className="flex items-center gap-2 mb-3">
              <span className="text-xs font-bold text-white bg-brand-primary px-3 py-1.5 rounded-full">
                APP Admin
              </span>
              <button
                onClick={() => setReloadKey((k) => k + 1)}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/15 text-white text-xs hover:bg-white/25 transition-colors"
                data-testid="demo-mobile-app-reload"
              >
                <RefreshCw size={14} /> Rafraîchir
              </button>
              <button
                onClick={() => setOpen(false)}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/15 text-white text-xs hover:bg-white/25 transition-colors"
                data-testid="demo-mobile-app-close"
              >
                <X size={14} /> Fermer
              </button>
            </div>

            {/* Cadre téléphone */}
            <div className="bg-black rounded-[40px] p-3 shadow-2xl" style={{ width: '410px', maxWidth: '95vw' }}>
              <div
                className="relative bg-white rounded-[30px] overflow-hidden"
                style={{ width: '386px', maxWidth: '100%', height: 'min(820px, 82vh)' }}
              >
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-black rounded-b-2xl z-10" />
                <iframe
                  key={reloadKey}
                  title="demo-mobile-app"
                  src={buildSrc()}
                  className="w-full h-full border-0"
                  data-testid="demo-mobile-app-iframe"
                />
              </div>
            </div>
            <p className="text-white/70 text-xs mt-3">Aperçu de l'application web admin (mobile)</p>
          </div>
        </div>
      )}
    </>
  );
};

export default DemoMobileAppButton;
